const VHS_EPISODES_SORTING = [
    { value: 'start_at-DESC', label: 'Most Recent First' },
    { value: 'start_at-ASC', label: 'Oldest First' },
    { value: 'created_at-ASC', label: 'Creation Date Asc' },
    { value: 'created_at-DESC', label: 'Creation Date Desc' },
];

export default VHS_EPISODES_SORTING;
